<template>
  <div class="bg" @click="hideTips">
    <div class="content pa bg_fff" @click.stop>
      <template v-if="tipsType===1">
        <template v-if="tipsState===1">
          <div class="title f_18 color_40 font_w_b">招聘信息不完整</div>
          <div class="tips f_14 color_blue">完善后可继续发布</div>
        </template>
        <template v-if="tipsState===2">
          <div class="title f_18 color_40 font_w_b">在线职位已达上限</div>
          <div class="text f_14 color_60">在线职位最多为 150 个，当前已达上限</div>
          <div class="tips f_14 color_blue">需关闭其他职位才能发布新职位</div>
        </template>
        <template v-if="tipsState===3">
          <div class="title f_18 color_40 font_w_b">发布失败</div>
          <div class="text f_14 color_60">已发布/保存过该职位信息</div>
          <div class="tips f_14 color_blue">可尝试修改职位名称后可继续发布</div>
        </template>
        <template v-if="tipsState===4">
          <div class="title f_18 color_40 font_w_b">保存失败</div>
          <div class="text f_14 color_60">已发布/保存过该职位信息</div>
          <div class="tips f_14 color_blue">可尝试修改职位名称后可继续保存</div>
        </template>

        <div class="formButtons templateButtons text_center clearfix">
          <div class="confirmButton f_14 fr" @click="hideTips">我知道了</div>
        </div>
      </template>
      <template v-else-if="tipsType === 2">
        <template v-if="tipsState===1">
          <div class="title f_18 color_40 font_w_b">关闭职位提示</div>
          <div class="text f_14 color_60">即将下线该职位</div>
          <div class="tips f_14 color_f64">是否确认下线</div>
        </template>
        <template v-else-if="tipsState===2">
          <div class="title f_18 color_40 font_w_b">删除草稿提示</div>
          <div class="text f_14 color_60">即将删除该职位草稿</div>
          <div class="tips f_14 color_f64">是否确认删除</div>
        </template>
        <template v-if="tipsState===3">
          <div class="title f_18 color_40 font_w_b">关闭职位提示</div>
          <div class="text f_14 color_60">该职位已购买精准曝光</div>
          <div class="tips f_14 color_f64">是否确认下线</div>
        </template>

         <div class="formButtons templateButtons text_center clearfix">
          <div class="confirmButton f_14 fr" @click="confirmButton">确认</div>
          <div class="cancelButton f_14 fr" @click="hideTips">取消</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name:'TipsBlock',
  data(){
    return {

    }
  },
  props:{
    tipsType:{
      default:1,
      type:Number
    },
    tipsState:{
      default:1,
      type:Number
    },
  },
  methods:{
    hideTips(){
      this.$emit('hideTipsF')
    },
    confirmButton(){
      this.$emit('confirmButtonF')
    },
  },
}
</script>

<style lang="scss" scoped>
  .bg{
    position: fixed;
    z-index: 9;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha:0.5);
    .content{
      width:446px;
      box-sizing: border-box;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.03);
      border-radius:4px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 32px 32px 26px;

      .title{
        line-height: 24px;
      }
      .text{
        line-height: 20px;
        margin: 17px 0 6px;
      }
      .tips{
        line-height: 20px;
      }
    }
  }
  .formButtons{
    margin-top: 25px;
    .confirmButton{
      width: auto;
      padding: 0 28px;
      height: 36px;
      line-height: 36px;
      margin-left: 16px;
    }
    .cancelButton{
      width: auto;
      padding: 0 28px;
      height: 36px;
      line-height: 36px;
    }
  }
</style>
